/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type contacts_CreateContactRequest = {
    addressForm?: contacts_CreateContactRequest.addressForm;
    addressId?: string;
    avatarUrl?: string;
    birthdate?: shared_FlexibleDate;
    clerkUserId?: string;
    /**
     * Optional, auto-generated if not provided
     */
    contactInternalId?: string;
    customerScore?: number;
    emailMain?: string;
    emailSecond?: string;
    employer?: string;
    firstname: string;
    gender?: contacts_CreateContactRequest.gender;
    labels?: Array<string>;
    languageCorrespondence?: contacts_CreateContactRequest.languageCorrespondence;
    lastname: string;
    nationalities?: Array<string>;
    notes?: string;
    profession?: string;
    telHome?: string;
    telHomeCountryCode?: string;
    telMobile?: string;
    telMobileCountryCode?: string;
    telWork?: string;
    telWorkCountryCode?: string;
    title?: string;
};
export namespace contacts_CreateContactRequest {
    export enum addressForm {
        FORMAL = 'FORMAL',
        INFORMAL = 'INFORMAL',
    }
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
        UNDEFINED = 'UNDEFINED',
    }
    export enum languageCorrespondence {
        EN = 'en',
        DE = 'de',
    }
}

